import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector, shallowEqual } from "react-redux";

export default function PaidWinningAmount(props) {
  const {printData} = useSelector((state) => state.ticket, shallowEqual);

  const { onHide, show, id, onTicket, barcode, putPaidWinningAmount } = props;

  const onPutPaid = (e) => {
    e.preventDefault();
    putPaidWinningAmount(barcode);
    // onTicket(barcode);
  };

  return (
      <Modal show={show} onHide={onHide} aria-labelledby="payment" centered>
        <form onSubmit={onPutPaid}>
          <Modal.Header closeButton>
            <Modal.Title id="payment">Uduş məbləğinin ödənişi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-12 pl-4 pr-4">
              <div className="row">Ödənişi ({printData.winningAmount}AZN) təsdiqləməyə əminsiniz?</div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={() => onHide(false)}>
              Ləğv
            </Button>
            <Button type="submit">Ödənişi tamamla</Button>
          </Modal.Footer>
        </form>
      </Modal>
  );
}
